<template>
    <div>
        <b-alert :show="isSuccess" variant="success">
            Your profile has been updated.
        </b-alert>

        <div class="form-group">
            <label>City/Location</label>
            <input type="text" class="form-control" v-model="user.city" :disabled="isBusy">
            <small class="form-text text-muted">
                This is used to show your location to other users.
            </small>
        </div>

        <div class="form-group">
            <label>Timezone</label>
            <select class="form-control" v-model="user.timezone" :disabled="isBusy">
                <option v-for="timezone in timezones" v-bind:value="timezone" v-bind:key="timezone">
                    {{ timezone }}
                </option>
            </select>
            <small class="form-text text-muted">
                We use this to show course and session times in your local timezone.
            </small>
        </div>

        <div class="form-group">
            <label>Mobile Number</label>

            <input type="text" class="form-control" v-model="user.phone" :disabled="isBusy">

            <small class="form-text text-muted">
                We'll send you an SMS just before your course or session is due to start so you don't miss it!
            </small>
        </div>

        <div class="form-group">
            <label>Mobile Number Country</label>

            <select class="form-control small" v-model="user.phone_country_code" :disabled="isBusy">
                <option v-for="country in countries" v-bind:value="country.alpha2" v-bind:key="country.alpha2">
                    {{ country.name }}
                </option>
            </select>

            <small class="form-text text-muted">
                We need to know what country your mobile is from - this is to make sure we're able to send you SMS messages reliably.
            </small>
        </div>

        <div class="form-group">
            <label>Date of Birth</label>
            <b-form-datepicker id="dob" v-model="user.dob" :max="maxDOB" class="mb-2" :disabled="isBusy" :dropup="true"></b-form-datepicker>
            <small class="form-text text-muted">
                As part of our verification processes we need to know your date of birth.
            </small>
        </div>

        <div class="form-group">
            <label>Gender</label>

            <select class="form-control small" v-model="user.gender_id" :disabled="isBusy">
                <option></option>
                <option v-for="gender in genders" v-bind:value="gender.id" v-bind:key="gender.gender">
                    {{ gender.gender }}
                </option>
            </select>

            <small class="form-text text-muted">
                We're actively helping more women to find their place in the music industry, so it's important to us to know your gender.
            </small>
        </div>

        <div class="row">
            <template v-if="!isOnboarding">
                <div class="col-md-6">
                    <button class="btn btn-success mt-3" :disabled="isBusy" @click="save">Save</button>
                </div>
            </template>
            <template v-else>
                <div class="col-md-6">
                    <button class="btn btn-primary mt-3" :disabled="isBusy" @click="saveOnboarding">Next</button>
                </div>

                <div class="col-md-6 align-self-end">
                    <div class="text-right">
                        <button class="btn btn-secondary btn-sm skip" :disabled="isBusy" @click="skip">Skip</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isOnboarding: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        data() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            
            // 15th in two months
            const maxDate = new Date(today)
            maxDate.setYear(maxDate.getFullYear() - 16);

            return {
                user: {
                    city: '',
                    timezone: 'Europe/London',
                    phone_country_code: 'GB',
                    phone: '',
                    dob: '', 
                },
                isSuccess: false,
                isBusy: false,
                isFormBusy: false,
                timezones: [],
                countries: [],
                genders: [],
                maxDOB: maxDate,
            }
        },

        mounted() {
            // Get the seed data
            if(!this.isOnboarding) {
                this.getProfile();
            }

            this.getGenders();
            this.getTimezones();
            this.getCountries();
        },

        methods: {
            // Skip
            skip() {
                Bus.$emit('stepComplete', {
                    'step': 'metaProfileInfo',
                    'skip': true,
                });
            },

            // Save 
            save() {
                this.isSuccess = false;
                this.isBusy = true;

                axios.post('/api/me/update', {
                    'user': this.user
                }).then((response) => {
                    this.isSuccess = true;
                    this.isBusy = false;
                });
            },

            // Save for onboarding
            saveOnboarding() {
                this.isBusy = true;

                axios.post('/api/me/update', {
                    'user': this.user
                }).then((response) => {
                    this.isBusy = false;
                    Bus.$emit('stepComplete', {
                        'step': 'metaProfileInfo',
                        'skip': false,
                        'percentageComplete': response.data.profileCompletePercentage,
                    });
                });
            },

            // Get the profile info
            getProfile() {
                this.isBusy = true;
                axios.get('/api/me/get-user').then((response) => {
                    this.isBusy = false;
                    this.user = response.data;
                });
            },

            // Get all timezones
            getTimezones() {
                axios.get('/api/timezones').then((response) => {
                    this.timezones = response.data;
                });
            },

            // Get all countries
            getCountries() {
                axios.get('/api/countries').then((response) => {
                    this.countries = response.data;
                });
            },

            // Get all countries
            getGenders() {
                axios.get('/api/genders').then((response) => {
                    this.genders = response.data;
                });
            },
        }
    }
</script>